import { BeaconTracker } from '@buzzfeed/third-party-analytics';
import {
  CLUSTER,
  quantcast_id,
} from '../../../constants';

export async function trackBeaconsPageview(buzz) {
  const tracker = new BeaconTracker({ client: 'bpage', cluster: CLUSTER });
  tracker.trackAll({
    buzz,
    qacct: quantcast_id,
  });
}
